import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Resultsearch from "../../../Components/Recherche/results_search/ResultDecisions/resultsearch";
import "./Decisionresult.css";
import Logo from "../../../Assets/logo.png";
import AdvancedFilters from "../../../Components/Filtres/filtre";
import { nextPage, previousPage } from "../../../utils/pagination";

const DecisionResult = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const initialQuery = searchParams.get("query") || "";
    const initialDecisionId = searchParams.get("decision-id") || "";
    const pageParam = searchParams.get("page") || "1";

    const [searchInput, setSearchInput] = useState(initialQuery);
    const [searchData, setSearchData] = useState({
        count: 0,
        next: null,
        previous: null,
        results: []
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [activeFilter, setActiveFilter] = useState("Décisions");
    const [currentQuery, setCurrentQuery] = useState(initialQuery);
    const [currentDecisionId, setCurrentDecisionId] = useState(initialDecisionId);
    const [isDecisionIdSearch, setIsDecisionIdSearch] = useState(!!initialDecisionId);
    const [currentPage, setCurrentPage] = useState(parseInt(pageParam, 10));
    const itemsPerPage = 10;

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const query = searchParams.get("query") || "";
        const decisionId = searchParams.get("decision-id") || "";
        const pageParam = searchParams.get("page") || "1";

        setCurrentQuery(query);
        setCurrentDecisionId(decisionId);
        setIsDecisionIdSearch(!!decisionId);
        setCurrentPage(parseInt(pageParam, 10));

        if (query) {
            setSearchInput(query);
        }
    }, [location.search]);

    useEffect(() => {
        if (currentQuery && !isDecisionIdSearch) {
            fetchResults(currentQuery, currentPage, false);
        } else if (currentDecisionId && isDecisionIdSearch) {
            fetchDecisionSimilaires(currentDecisionId, currentPage);
        }
    }, [currentQuery, currentDecisionId, isDecisionIdSearch, currentPage]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        params.set("page", currentPage.toString());

        window.history.pushState(
            {},
            "",
            `${location.pathname}?${params.toString()}`
        );
    }, [currentPage, location.search]);

    const fetchResults = async (query, page = 1, isDecisionId = false) => {
        if (!query) return;

        setLoading(true);
        setError(null);
        setCurrentQuery(query);
        setIsDecisionIdSearch(isDecisionId);
        setCurrentPage(page);

        try {
            const payload = {
                search: query,
                limit: itemsPerPage,
            };

            const url = `${process.env.REACT_APP_API_URL}/recouv/decision-list?page=${page}`;

            const response = await fetch(url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error("Une erreur est survenue lors de la récupération des données.");
            }

            const data = await response.json();

            setSearchData(data);
        } catch (err) {
            setError(err.message);
            console.error("Erreur lors de la recherche:", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchDecisionSimilaires = async (id, page = 1) => {
        if (!id) return;

        setLoading(true);
        setError(null);
        setIsDecisionIdSearch(true);
        setCurrentDecisionId(id);
        setCurrentPage(page);

        try {
            const url = `${process.env.REACT_APP_API_URL}/recouv/decision-keywords/${id}?page=${page}`;
            console.log("Fetching similar decisions URL:", url);

            const response = await fetch(url, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                }
            });

            if (!response.ok) {
                throw new Error(`Erreur HTTP: ${response.status}`);
            }

            const contentType = response.headers.get("content-type");
            if (!contentType || !contentType.includes("application/json")) {
                throw new Error(`Réponse non JSON reçue: ${contentType}`);
            }

            const data = await response.json();

            if (data && data.results) {
                setSearchData({
                    count: data.count || data.results.length,
                    results: data.results,
                    next: data.next,
                    previous: data.previous
                });
            } else {
                setSearchData({
                    count: 0,
                    next: null,
                    previous: null,
                    results: []
                });
                setSearchInput("Aucune décision similaire trouvée");
            }
        } catch (err) {
            console.error("Erreur lors du chargement des décisions similaires:", err);
            setError(`Erreur: ${err.message}`);
        } finally {
            setLoading(false);
        }
    };

    const handleSearch = (e) => {
        e.preventDefault();
        if (searchInput.trim()) {
            setIsDecisionIdSearch(false);
            setCurrentDecisionId("");

            const params = new URLSearchParams(location.search);
            params.delete("decision-id");
            params.set("query", searchInput.trim());
            params.set("page", "1");

            window.history.pushState(
                {},
                "",
                `${location.pathname}?${params.toString()}`
            );

            // Lancer la recherche normale
            fetchResults(searchInput.trim(), 1, false);
        }
    };

    const handleFilterClick = (filter) => {
        setIsDecisionIdSearch(false);
        setCurrentDecisionId("");

        setActiveFilter(filter);
        setSearchInput(filter);

        const params = new URLSearchParams(location.search);
        params.delete("decision-id");
        params.set("query", filter);
        params.set("page", "1");

        window.history.pushState(
            {},
            "",
            `${location.pathname}?${params.toString()}`
        );

        fetchResults(filter, 1, false);
    };

    const handleFilterChange = (filterData) => {
        console.log("Filter changed:", filterData);
    };

    const handlePageChange = async (page) => {
        console.log("Page change requested to:", page);
        console.log("Current state:", {
            isDecisionIdSearch,
            currentDecisionId,
            currentQuery,
            currentPage
        });

        setCurrentPage(page);

        // Mise à jour de l'URL
        const params = new URLSearchParams(location.search);
        params.set("page", page.toString());
        window.history.pushState({}, "", `${location.pathname}?${params.toString()}`);

        try {
            setLoading(true);

            if (isDecisionIdSearch && currentDecisionId) {

                if (searchData.next && page > currentPage) {
                    console.log("Using next URL:", searchData.next);
                    const response = await fetch(searchData.next, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" }
                    });

                    if (!response.ok) {
                        throw new Error(`Erreur HTTP: ${response.status}`);
                    }

                    const data = await response.json();
                    setSearchData({
                        count: data.count || data.results.length,
                        results: data.results,
                        next: data.next,
                        previous: data.previous
                    });
                }
                else if (searchData.previous && page < currentPage) {
                    console.log("Using previous URL:", searchData.previous);
                    const response = await fetch(searchData.previous, {
                        method: "GET",
                        headers: { "Content-Type": "application/json" }
                    });

                    if (!response.ok) {
                        throw new Error(`Erreur HTTP: ${response.status}`);
                    }

                    const data = await response.json();
                    setSearchData({
                        count: data.count || data.results.length,
                        results: data.results,
                        next: data.next,
                        previous: data.previous
                    });
                }
                else {
                    fetchDecisionSimilaires(currentDecisionId, page);
                }
            }
            else if (currentQuery) {
                console.log("Processing as regular search");

                const payload = { search: currentQuery, limit: itemsPerPage };

                if (searchData.next && page > currentPage) {
                    console.log("Using next URL for regular search");
                    const data = await nextPage(searchData.next, payload);
                    if (data.next) {
                        data.next = `${process.env.REACT_APP_API_URL}/recouv/decision-list${data.next.substring(data.next.indexOf('?'))}`;
                    }
                    if (data.previous) {
                        data.previous = `${process.env.REACT_APP_API_URL}/recouv/decision-list${data.previous.substring(data.previous.indexOf('?'))}`;
                    }
                    setSearchData(data);
                }
                else if (searchData.previous && page < currentPage) {
                    console.log("Using previous URL for regular search");
                    const data = await previousPage(searchData.previous, payload);
                    if (data.next) {
                        data.next = `${process.env.REACT_APP_API_URL}/recouv/decision-list${data.next.substring(data.next.indexOf('?'))}`;
                    }
                    if (data.previous) {
                        data.previous = `${process.env.REACT_APP_API_URL}/recouv/decision-list${data.previous.substring(data.previous.indexOf('?'))}`;
                    }
                    setSearchData(data);
                }
                // else {
                //     fetchResults(currentQuery, page, false);
                // }
            }
        } catch (err) {
            console.error("Erreur lors du changement de page:", err);
            // setError("Erreur lors du changement de page: " + (err.message || "Erreur inconnue"));
        } finally {
            setLoading(false);
        }
    };

    const handleLogin = () => {
        window.location.href = "https://datagreffe.ci/dashboard";
    };

    return (
        <div className="pappers-search-page">
            {/* Header avec logo */}
            <header className="search-header">
                <div className="logo-container">
                    <Link to="/">
                        <img src={Logo} alt="Logo" className="justice-logo" />
                    </Link>
                    <h1 className="text-xl font-bold">Datagreffe justice</h1>
                </div>

                <div className="search-container">
                    <form onSubmit={handleSearch} className="search-form">
                        <div className="search-input-container">
                            <span className="search-icon">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                                </svg>
                            </span>
                            <input
                                type="text"
                                value={searchInput}
                                onChange={(e) => setSearchInput(e.target.value)}
                                placeholder="Mot-clé, référence, juridiction, 'expression exacte', ..."
                                className="search-input"
                            />
                        </div>

                        <div className="search-filter-dropdown">
                            <button type="button" className="filter-button">
                                <span className="filter-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z" />
                                    </svg>
                                </span>
                                Décisions
                                <span className="dropdown-icon">▼</span>
                            </button>
                        </div>

                        <button type="submit" className="search-button">
                            Rechercher
                        </button>
                    </form>
                </div>

                <div className="login-container">
                    <button className="login-button" onClick={handleLogin}>
                        Se connecter
                    </button>
                </div>
            </header>

            {!isDecisionIdSearch && <AdvancedFilters onFilterChange={handleFilterChange} />}

            <div className="search-results-container">
                {isDecisionIdSearch && (
                    <div className="px-5 py-4">
                        <h2 className="text-2xl font-semibold text-gray-800 mb-2">Toutes les décisions similaires</h2>
                    </div>
                )}

                {error && <div className="error-message"><p>{error}</p></div>}

                {loading ? (
                    <div className="loading-message">
                        <div className="loading-spinner"></div>
                        <p>Chargement des résultats...</p>
                    </div>
                ) : (
                    searchData.results.length > 0 ? (
                        <Resultsearch
                            data={searchData}
                            searchQuery={currentQuery}
                            onPageChange={handlePageChange}
                        />
                    ) : (
                        (currentQuery || currentDecisionId) && <div className="no-results">
                            <p>Aucun résultat trouvé pour votre recherche.</p>
                            <p>Essayez de modifier vos critères de recherche ou d'utiliser des termes plus généraux.</p>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default DecisionResult;
